import axiosIns from '@/libs/axios'
import utilsService from './utilsService'

const controller = 'pontuacaoManual'

export default {
  async getAll(filter) {
    // Limpa o filtro removendo valores vazios
    const cleanFilter = utilsService.cleanObject(filter)
    
    return axiosIns
      .get(`${controller}?${utilsService.getQueryParams(cleanFilter)}`)
      .then(res => res.data)
  },
  async getById(id) {
    return axiosIns.get(`${controller}/${id}`).then(res => res.data)
  },
  async update(obj) {
    return axiosIns.put(`${controller}/${obj.id}`, obj).then(res => res.data)
  },
  async create(req) {
    return axiosIns.post(controller, req).then(res => res.data)
  },
  async delete(id) {
    return axiosIns.delete(`${controller}/${id}`).then(res => res.data)
  },
}





